import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import ModalBasicLayout from "./ModalBasicLayout";
import ContainerModalActions from "../Containers/ContainerModalActions";
import SelectYouTubeAccountWithConnect from "../Gallery/ShareModalMultiple/components/SelectYouTubeAccountWithConnect";
import TextField from "../Form/TextField";
import Button from "../Buttons/Button";
import CardMedia from "../Media/CardMedia";
import { useUploadYoutubeVideoModal } from "../../hooks/useUploadYoutubeVideoModal";
import { useTranslationApp } from "../../lib/i18next";
import {
  BUTTON_CHANGE_CONTENT,
  BUTTON_GO_BACK,
  BUTTON_SELECT_VIDEO,
  BUTTON_SHARE_LOADING,
  BUTTON_SHARE_MEDIA,
  MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE,
  YOUTUBE_ACCOUNT_PLACEHOLDER,
  YOUTUBE_TITLE_LABEL,
} from "../../i18n/keysTranslations";

const ModalUploadYoutubeVideo = ({
  modalOpen = false,
  onCloseModal = () => {},
  language = "es",
  onCallbackSave = () => {},
}) => {
  const { t } = useTranslationApp();
  const {
    control,
    errors,
    selectedVideo,
    isPublishing,
    onOpenGallery,
    onPublish,
    galleryModal,
    fieldRequiredMessage,
  } = useUploadYoutubeVideoModal({
    modalOpen,
    onCloseModal,
    language,
    onCallbackSave,
  });

  return (
    <>
      <ModalBasicLayout
        modalOpen={modalOpen}
        onCloseModal={onCloseModal}
        title={t(MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE)}
        maxWidth="sm"
        fullWidth
        ariaLabel={t(MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE)}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <SelectYouTubeAccountWithConnect
            variant="filled"
            name="account"
            label={t(YOUTUBE_ACCOUNT_PLACEHOLDER)}
            fullWidth
            control={control}
            errors={errors}
            rules={{
              required: {
                value: true,
                message: fieldRequiredMessage,
              },
            }}
          />

          <TextField
            label={t(YOUTUBE_TITLE_LABEL)}
            name="title"
            variant="filled"
            fullWidth
            control={control}
            errors={errors}
            rules={{
              required: {
                value: true,
                message: fieldRequiredMessage,
              },
            }}
          />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Button
              color="secondary"
              fullWidth
              onClick={onOpenGallery}
              sx={{ textTransform: "none" }}
            >
              {selectedVideo?.url
                ? t(BUTTON_CHANGE_CONTENT)
                : t(BUTTON_SELECT_VIDEO)}
            </Button>

            {selectedVideo?.url ? (
              <Box
                sx={{
                  width: "100%",
                  maxHeight: 280,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 2,
                  overflow: "hidden",
                  bgcolor: "fields.background",
                }}
              >
                <CardMedia
                  url={selectedVideo.url}
                  propsType={{
                    controls: true,
                    controlsList: "nodownload",
                    autoplay: false,
                    loop: false,
                    muted: true,
                  }}
                  sxVideo={{
                    width: "100%",
                    maxHeight: 280,
                    objectFit: "contain",
                    borderRadius: 2,
                  }}
                />
              </Box>
            ) : null}
          </Box>
        </Box>

        <DialogActions sx={{ px: 0, pt: 2, pb: 0 }}>
          <ContainerModalActions
            hasPadding={true}
            propsSecondaryButton={{
              showButton: true,
              onClick: onCloseModal,
              text: BUTTON_GO_BACK,
              disabled: isPublishing,
            }}
            propsPrimaryButton={{
              showButton: true,
              onClick: onPublish,
              text: isPublishing ? BUTTON_SHARE_LOADING : BUTTON_SHARE_MEDIA,
              type: "button",
              loading: isPublishing,
              disabled: isPublishing || !selectedVideo?.url,
            }}
          />
        </DialogActions>
      </ModalBasicLayout>

      {galleryModal}
    </>
  );
};

export default ModalUploadYoutubeVideo;
